import { ApplicationRef, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * @deprecated please use the `ConfirmDialogService` instead
 */
export class ConfirmationDialogModel {
  constructor(data: Partial<ConfirmationDialogModel>) {
    this.header_text = data.header_text ? data.header_text : 'Delete Confirmation';
    this.text = data.text || '';
    this.confirmation_text = data.confirmation_text ? data.confirmation_text : 'Delete';
    this.data = data.data;
  }

  header_text: string;
  text: string;
  confirmation_text: string;
  data: unknown;
}

/**
 * @deprecated please use the `ConfirmDialogService` instead
 */
@Component({
  selector: 'y42-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogModel,
    public applicationRef: ApplicationRef,
  ) {}

  ngOnInit() {
    this.data = new ConfirmationDialogModel(this.data);
  }

  onClick(isSubmit: boolean) {
    if (isSubmit) {
      this.dialogRef.close(this.data.data);
    } else {
      this.dialogRef.close();
    }
    // workaround to detect changes when onPush (else popup won't close)
    setTimeout(() => {
      this.applicationRef.tick();
    }, 50);
  }
}
